module.exports = __webpack_public_path__ + "img/hammer-and-pick.2fb70a8a.png";